import React from 'react';
import LargeButton from '@/components/Views/Buttons';
import { useRouter } from 'next/router';
import { Image } from 'react-datocms';
import { useDispatchUi } from '@/context/ui';
import { MUZOLOGY_APP, MUZOLOGY_SIGNUP_URL } from '@/lib/defaults';
const TryFree = ({ id, images }) => {
    const router = useRouter();
    const dispatch: any = useDispatchUi();
    return (
        <div
            className='pb-20 lg:pb-40 pt-0 lg:pt-24 px-4 sm:px-10  '
            style={{ background: 'linear-gradient(180deg, #FEFEFE 55.23%, #F4F4F4 70.57%, #5667BD 95.02%)' }}
        >
            <div className='default-max-w mx-auto'>
                <div className='flex justify-between items-center flex-col lg:flex-row gap-6 lg:gap-0'>
                    <div>
                        <div className='max-w-[480px] xl:max-w-[580px] text-[#28294E]'>
                            <div className=' block lg:hidden text-[24px] md:text-[28px] font-extrabold mt-5 text-center'>LEARNING MATH,</div>
                            <br className='block lg:hidden' />
                            <div className=' block lg:hidden text-[24px] md:text-[28px]  font-extrabold text-center -mt-4'>MINUS THE ANXIETY</div>
                            <Image data={{ ...images[0]?.responsiveImage, bgColor: '#ffffff00' }} />
                            <div className=' hidden lg:block text-[24px] md:text-[28px] leading-9 font-extrabold mt-5'>LEARNING MATH, MINUS THE ANXIETY</div>
                            <div className='text-lg  font-normal mt-5'>
                                <span className='font-extrabold'>Muzology</span> takes the anxiety and stress out of learning the 'hardest' (and most important)
                                subject. A happy kid equals a happy house — that's just a simple equation!
                            </div>
                            <div className='text-lg font-normal mt-5'>Try Muzology today for FREE with a 7-day trial.</div>
                            <div className='flex flex-col md:flex-row gap-3 md:gap-4 justify-between items-center   md:justify-start md:items-center pr-7 mt-6 sm:mt-7 lg:mt-10'>
                                <LargeButton
                                    onClick={() => {
                                        window.location.href = MUZOLOGY_SIGNUP_URL;
                                    }}
                                    className='purple-button w-full max-w-[220px] xl:max-w-[230px] h-[40px] uppercase relative'
                                    id={id + '-sign-up-my-child'}
                                >
                                    <div className='flex items-center justify-start'>
                                        <div className='text-white font-Inter font-medium'>Sign Up My Child</div>
                                    </div>
                                </LargeButton>
                                <LargeButton
                                    className='dark-button transition-all w-full max-w-[220px] xl:max-w-[230px] uppercase px-0'
                                    text='Kids Love It'
                                    rightDelta={true}
                                    id={id + '-kids-love-it'}
                                    onClick={() => dispatch({ type: 'PLAY_VIDEO', payload: 'https://vimeo.com/849753653' })}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='mt-6 lg:mt-0'>
                        <div className='max-w-[480px] xl:max-w-[580px] text-[#28294E]'>
                            <div className='block lg:hidden text-[24px] md:text-[28px] leading-9 font-extrabold mt-5 text-center'>
                                THE BEST TEACHER'S ASSISTANT
                            </div>

                            <Image data={{ ...images[1]?.responsiveImage, bgColor: '#ffffff00' }} />

                            <div className='hidden lg:block text-[24px] md:text-[28px] leading-9 font-extrabold mt-5'>THE BEST TEACHER'S ASSISTANT</div>
                            <div className='text-lg  font-normal mt-5'>
                                For educators, <span className='font-extrabold'>Muzology</span> is easy to implement, supports rigorous math standards and
                                supplements most math curricula for upper elementary and middle school students.
                            </div>
                            <div className='text-lg font-normal mt-5'>As an educator, you can try Muzology FREE with a 14-day trial.</div>
                            <div className='flex flex-col md:flex-row gap-3 md:gap-4 justify-between items-center md:justify-start md:items-center pr-7 mt-6 sm:mt-7 lg:mt-10'>
                                <LargeButton
                                    onClick={() => router.push('/signup')}
                                    className='blue-button max-w-[220px] xl:max-w-[230px] w-full h-[40px] relative'
                                    id={id + '-sign-up-as-educator'}
                                >
                                    <div className='flex items-center justify-start'>
                                        <div className='text-white font-Inter font-medium uppercase'>Sign Up As Educator</div>
                                    </div>
                                </LargeButton>
                                <LargeButton
                                    className='dark-button transition-all w-full max-w-[220px] xl:max-w-[230px] uppercase px-0'
                                    text='Teachers Love It'
                                    rightDelta={true}
                                    id={id + '-teachers-love-it'}
                                    onClick={() => dispatch({ type: 'PLAY_VIDEO', payload: 'https://vimeo.com/849753666' })}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TryFree;
